import { type FC, type PropsWithChildren, useCallback } from 'react';
import Link from 'next/link';
import { useTypedDispatch } from '@/hooks';
import { setShowMobileCoupon } from '@/store';
import type { CompetitorsWrapperProps } from './CompetitorsWrapper.types';
export const CompetitorsWrapper: FC<PropsWithChildren<CompetitorsWrapperProps>> = ({
  children,
  className,
  lineHref
}) => {
  const dispatch = useTypedDispatch();
  const handleClickLink = useCallback(() => {
    dispatch(setShowMobileCoupon(false));
  }, [dispatch]);
  if (!lineHref) {
    return <div className={className}>{children}</div>;
  }
  return <Link className={className} href={lineHref} onClick={handleClickLink} data-sentry-element="Link" data-sentry-component="CompetitorsWrapper" data-sentry-source-file="CompetitorsWrapper.tsx">
      {children}
    </Link>;
};